import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import Navigation from "../partials/Navigation";
import Boards from "../partials/Boards";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import { getUserData } from "../redux/actions/userdata";
import { useDispatch, useSelector } from "react-redux";
import { getExpiry } from "../common";

const MyBoards = () => {
  const [cookies] = useCookies([
    "sustainyou_user_jwt",
    "sustainyou_jwt_issued",
    "sustainyou_jwt_expire",
  ]);
  const [translation] = useTranslation("translations");
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userdata.allUserData);

  useEffect(() => {
    let expired = getExpiry("user_data_expire");

    const getAllUserData = async (token) => {
      await dispatch(getUserData(token));
    };

    if (cookies.sustainyou_user_jwt) {
      //const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

      if (expired) {
        getAllUserData(cookies.sustainyou_user_jwt);
      }
    }
  }, [cookies, dispatch]);

  return (
    <div className="main-wrapper">
      <Helmet>
        <title>{translation("my_boards")}</title>
        <meta name="description" content="" />
      </Helmet>

      <Navigation />

      <div className="page-content-wrap">
        <HorizontalNav title="Change boards" />

        <div className="pt-5 pt-lg-0 page-content-inner">
          <Boards
            displayType="my-boards"
            memberships={userData?.membership_slugs}
            boardsLimit={userData?.boards_limit}
            capabilities={userData?.all_capabilities}
          />
        </div>
      </div>
    </div>
  );
};

export default MyBoards;
